class CheckBirthDate {
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._init();
    }

    _init() {
        this._cacheSelectors();
        this._bindEvents();
        this._handleOnInit();
    }

    _cacheSelectors() {
        const element = this._element;
        const attributeLabel = 'data-checkbirthdate';

        this._elements = {
            birthDate: element.querySelector(`[${attributeLabel}-birthdate]`),
            startingDate: element.querySelector(`[${attributeLabel}-effective-date]`),
            messageUnderaged: element.querySelector(`[${attributeLabel}-message-underaged]`),
            messageAlmostaged: element.querySelector(`[${attributeLabel}-message-almostaged]`),
            loader: element.querySelector(`[${attributeLabel}-loader]`),
            nextSection: element.querySelector(`[${attributeLabel}-next-section]`)
        };
    }

    _bindEvents() {
        const { birthDate } = this._elements;

        if(birthDate) {
            birthDate.addEventListener('blur', this._handleBirthDate.bind(this));
        }
    }

    _handleOnInit() {
        this._disableStartingDate(true);
        this._hideLoader();
        this._hideMessageUnderaged();
        this._hideMessageAlmostaged();
        this._showNextSection();

        this.birthDate = null;
    }


    _handleBirthDate({currentTarget: element}) {
        if(this.birthDate !== element.value) {
            this._checkBirthDate(element.value);

            this.birthDate = element.value;
        }
    }

    async _checkBirthDate(birthDate) {
        const url = this._options.checkbirthdateUrl;
        const fetchData = { birthDate };
        const fetchProps = {
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type":
                    "application/json; charset=UTF-8"
            },
            method: 'POST',
            mode: "cors",
            body: JSON.stringify(fetchData)
        };

        this._disableStartingDate(true);
        this._showLoader();

        const resData = await fetch(url, fetchProps)
            .then(response => {
                if(response.ok) {
                    return response.json();
                } else {
                    console.log('Bad request...');
                }
            })
            .catch(err => console.error(err));

        this._hideLoader();

        if(resData) {
            this._handleNextStep(resData);
        } else {
            console.error('No data received from server...');
        }
    }

    _handleNextStep(conditions) {
        const { startingDate, startingDateChangeable, canUserProceed } = conditions;

        this._fillStartingDate(startingDate);
        this._triggerStartingDate();
        this._disableStartingDate(!startingDateChangeable);

        if(startingDateChangeable) {
            this._hideMessageAlmostaged();
        } else {
            this._showMessageAlmostaged();
        }

        if(canUserProceed) {
            this._hideMessageUnderaged();
            this._showNextSection();
        } else {
            this._showMessageUnderaged();
            this._hideNextSection();
        }
    }

    _disableStartingDate(boolean) {
        const { startingDate } = this._elements;

        if (startingDate) {
            startingDate.disabled = boolean;
        }
    }

    _fillStartingDate(value) {
        const { startingDate } = this._elements;

        // set element value
        startingDate.value = value;
    }

    /**
     * Trigger change event so other JS modules can react with the element
     * @private
     */
    _triggerStartingDate() {
        const { startingDate } = this._elements;
        const datepickers = document.querySelectorAll('.pika-single');
        const changeEvent = new Event('change');
        const blurEvent = new Event('blur');

        startingDate.dispatchEvent(changeEvent);
        // startingDate.dispatchEvent(blurEvent);

        // Make sure datepicker doesn't show up on change
        this._hideDatepickers(datepickers);
    }

    _hideDatepickers(elements) {
        [...elements].map(picker => picker.classList.add('is-hidden'));
    }

    _showLoader() {
        const { loader } = this._elements;

        loader.classList.remove('is-hidden');
    }

    _hideLoader() {
        const { loader } = this._elements;

        loader.classList.add('is-hidden');
    }

    _showMessageUnderaged() {
        const { messageUnderaged } = this._elements;

        messageUnderaged.classList.remove('is-hidden');
    }

    _hideMessageUnderaged() {
        const { messageUnderaged } = this._elements;

        messageUnderaged.classList.add('is-hidden');
    }

    _showMessageAlmostaged() {
        const { messageAlmostaged } = this._elements;

        messageAlmostaged.classList.remove('is-hidden');
    }

    _hideMessageAlmostaged() {
        const { messageAlmostaged } = this._elements;

        messageAlmostaged.classList.add('is-hidden');
    }

    _showNextSection() {
        const { nextSection } = this._elements;

        nextSection.classList.remove('is-hidden');
    }

    _hideNextSection() {
        const { nextSection } = this._elements;

        nextSection.classList.add('is-hidden');
    }

    get birthDate() {
        return this._birthDate;
    }

    set birthDate(value) {
        this._birthDate = value;
    }
}
